import React, { useState } from "react";
import { ProofPackButton } from "./ProofPackButton";
import { MarkTestDialog } from "./MarkTestDialog";

/**
 * Bulk-action bar shown above the leads table when 1+ rows are selected.
 * Exports for CSV/XLSX are available to anyone with `export_leads`; the
 * mark/unmark mutations remain internal-only.
 */
export default function LeadsBulkActions({
  selectedCount, selectedIds = [], canExport, isInternal, onExport, onBulk,
  archived = "active",
  onArchive, onRestore, onMarked,
}) {
  const [markOpen, setMarkOpen] = useState(false);
  if (selectedCount === 0) return null;
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="bulk-lead-bar">
      <span className="text-[11px] uppercase tracking-widest">{selectedCount} selected</span>
      <ProofPackButton leadIds={selectedIds} />
      {canExport && (
        <>
          <button onClick={() => onExport("csv", true)} data-testid="bulk-export-csv"
            className="border border-black px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-black hover:text-white">
            Export CSV
          </button>
          <button onClick={() => onExport("xlsx", true)} data-testid="bulk-export-xlsx"
            className="border border-black px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-black hover:text-white">
            Export XLSX
          </button>
        </>
      )}
      {isInternal && (
        <>
          <button onClick={() => setMarkOpen(true)} data-testid="bulk-mark-test"
            className="border border-black px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-black hover:text-white">Mark test</button>
          <button onClick={() => onBulk("unmark_test")} data-testid="bulk-unmark-test"
            className="border border-black px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-black hover:text-white">Unmark test</button>
          <button onClick={() => onBulk("mark_delivered")} data-testid="bulk-mark-delivered"
            className="border border-black px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-black hover:text-white">Mark delivered</button>
          {archived !== "archived" && onArchive && (
            <button onClick={onArchive} data-testid="bulk-archive"
              className="border-2 border-amber-700 bg-amber-50 text-amber-900 px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-amber-700 hover:text-white">
              Archive selected
            </button>
          )}
          {archived !== "active" && onRestore && (
            <button onClick={onRestore} data-testid="bulk-restore"
              className="border-2 border-emerald-700 bg-emerald-50 text-emerald-900 px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-emerald-700 hover:text-white">
              Restore selected
            </button>
          )}
        </>
      )}
      {markOpen && <MarkTestDialog ids={selectedIds} onClose={() => setMarkOpen(false)} onDone={onMarked} />}
    </div>
  );
}
